// New CRM (crm.soroban.ua) inbound endpoint configuration.
let url = "https://crm.soroban.ua";
// url = "http://local.soroban.ua:9000";
export const CRM_TOKEN = "crm-d5ae915de3d77ab28d9521ada193699ff416cf09e69cdd6c";
export default url;
